import * as types from "./actionTypes";
import { getLayout, getState } from "../store/configureStore";
import * as DomainConstants from '../constants/DomainConstants';
import { getFirstValidatieStatusForLusSideNav } from "../components/layout/NavItemHelper";
import * as componentConstants from "../constants/ComponentConstants";
import mergeDeep from "../util/mergeDeep";
import capitalize from "../util/stringFormatter";
function setTabNav(layout, modelId, validatieStatussen = [], herkomst, isDisabled) {
	const firstValidatieStatusForLus = getFirstValidatieStatusForLusSideNav(validatieStatussen);
	if (firstValidatieStatusForLus) {
		layout.topNavTabSettings.lussenTab.disabled = false;
		layout.topNavTabSettings.lussenTab.urlSuffix = `/lussen/${modelId}/${firstValidatieStatusForLus.entiteitGuid}`;
	}
	else
		layout.topNavTabSettings.lussenTab.disabled = true;

	if (layout.topNavTabsSet)
		return;

	layout.topNavTabsSet = true;
	layout.topNavTabSettings.organisatorTab.urlSuffix += `${modelId}/${herkomst}/${isDisabled}`;
	layout.topNavTabSettings.veldtoertochtTab.urlSuffix += modelId;
	layout.topNavTabSettings.toelatingenTab.urlSuffix += modelId;
	layout.topNavTabSettings.samenvattingTab.urlSuffix += modelId;
	layout.topNavTabSettings.publicatieTab.urlSuffix += modelId;

	const state = getState();

	if (!state?.security?.roles) {
		return;
	}

	const isOrganisator = state.security.roles.isOrganisator;
	const isBeoordelingGemeente = state.security.roles.isBeoordelingGemeente;
	const isBeoordelingFedOrKoepel = state.security.roles.isBeoordelingFedOrKoepel;
	if (isBeoordelingFedOrKoepel && herkomst === "goedkeuren") {
		layout.topNavTabSettings.naarOverzichtTab.urlSuffix += "/kalenderGoedkeuren";
	} else if (isBeoordelingGemeente && herkomst === "gemeente") {
		layout.topNavTabSettings.naarOverzichtTab.urlSuffix += "/gemeente/veldtoertochten";
	} else if (isBeoordelingFedOrKoepel && herkomst === "federatie") {
		layout.topNavTabSettings.naarOverzichtTab.urlSuffix += "/federatieOverzicht";
	} else if (isOrganisator) {
		layout.topNavTabSettings.naarOverzichtTab.urlSuffix += "/veldtoertochten";
	} else if (isBeoordelingGemeente) {
		layout.topNavTabSettings.naarOverzichtTab.urlSuffix += "/gemeente/veldtoertochten";
	} else if (isBeoordelingFedOrKoepel) {
		layout.topNavTabSettings.naarOverzichtTab.urlSuffix += "/federatieOverzicht";
	}
}

export function layoutUpdated(layout) {
	return {
		type: types.LAYOUT_UPDATED,
		body: layout
	};
}

export function loadConflictBeoordelingLayout(pageTitle, modelId, validatieStatussen, svlDossierId) {
return function (dispatch) {
		let layout = getDefaultLayout();
		layout.showHeader = true;
		layout.showTopNav = false;
		layout.pageHeaderTitle = "";
		layout.showBeads = false;
		resetTopNavTabSettings(layout);

		return dispatch(layoutUpdated(layout));
	};
}

export function loadToelatingenLayout(pageTitle, modelId, validatieStatussen, svlDossierId) {
	return function (dispatch) {
		let layout = getDefaultLayout();

		setTabNav(layout, modelId, validatieStatussen, false);

		layout.showHeader = true;
		layout.showBeads = true;
		layout.pageHeaderTitle = pageTitle;
		layout.svlDossierId = svlDossierId;

		return dispatch(layoutUpdated(layout));
	};
}

export function loadPublicatieLayout(pageTitle, modelId, validatieStatussen, svlDossierId) {
	return function (dispatch) {
		let layout = getDefaultLayout();

		setTabNav(layout, modelId, validatieStatussen, false);

		layout.showHeader = true;
		layout.showBeads = true;
		layout.pageHeaderTitle = pageTitle;
		layout.svlDossierId = svlDossierId;
		return dispatch(layoutUpdated(layout));
	};
}

export function loadGemeentePDFLayout(pageTitle, modelId, validatieStatussen) {
	return function (dispatch) {
		let layout = getDefaultLayout();

		setTabNav(layout, modelId, validatieStatussen, false);

		layout.showHeader = true;
		layout.showTopNav = false;
		layout.showBeads = false;
		layout.pageHeaderTitle = pageTitle;

		return dispatch(layoutUpdated(layout));
	};
}

export function loadOrganisatorLayout(pageTitle, modelId, validatieStatussen, isPageDisabled, herkomst, svlDossierId, redenVanStatus) {
	return function (dispatch) {
		let layout = getDefaultLayout();
		resetTopNavTabSettings(layout);
		setTabNav(layout, modelId, validatieStatussen, herkomst, isPageDisabled);
		layout.redenVanStatus = redenVanStatus;
		layout.showHeader = true;
		layout.showBeads = true;
		layout.pageHeaderTitle = pageTitle;
		layout.svlDossierId = svlDossierId;

		return dispatch(layoutUpdated(layout));
	};
}

export function loadLusLayout(pageTitle, modelId, validatieStatussen, lusId, svlDossierId) {
	return function (dispatch) {
		let layout = getDefaultLayout();

		setTabNav(layout, modelId, validatieStatussen, false);

		layout.showHeader = true;
		layout.showBeads = true;
		layout.showSideNav = true;
		layout.pageHeaderTitle = pageTitle;
		layout.svlDossierId = svlDossierId;


		const urlLussenSplit = layout.topNavTabSettings.lussenTab.urlSuffix.split('/');
		layout.topNavTabSettings.lussenTab.urlSuffix = urlLussenSplit.slice(0, urlLussenSplit.length - 1).join('/') + `/${lusId}`;

		return dispatch(layoutUpdated(layout));
	};
}

export function loadDemoPageLayout(pageTitle, isNew, modelId) {
	return function (dispatch) {
		let layout = getDefaultLayout();

		if (!isNew)
			setTabNav(layout, modelId);

		layout.showHeader = !isNew;
		layout.pageHeaderTitle = pageTitle;


		return dispatch(layoutUpdated(layout));
	};
}

export function loadUpdateTochtPageLayout(pageTitle, modelId, validatieStatussen, svlDossierId) {
	return function (dispatch) {
		let layout = getDefaultLayout();

		setTabNav(layout, modelId, validatieStatussen, false);

		layout.showHeader = true;
		layout.showBeads = true;
		layout.pageHeaderTitle = pageTitle;
		layout.svlDossierId = svlDossierId;

		return dispatch(layoutUpdated(layout));
	};
}

export function loadTestPageLayout() {
	return function (dispatch) {
		let layout = getDefaultLayout();

		layout.showHeader = false;
		layout.showBeads = false;
		return dispatch(layoutUpdated(layout));
	};
}

export function loadTochtPageLayout(pageTitle) {

	return function (dispatch) {
		let layout = getDefaultLayout();

		layout.showHeader = false;
		layout.showBeads = false;
		layout.pageHeaderTitle = pageTitle;


		return dispatch(layoutUpdated(layout));
	};
}

export function loadDefaultLayout() {
	return function (dispatch) {
		return dispatch(layoutUpdated(getDefaultLayout()));
	};
}

export function loadDefaultEmptyLayout() {
	return function (dispatch) {
		let layout = getDefaultLayout();

		layout.showHeader = false;
		layout.pageHeaderTitle = "";

		return dispatch(layoutUpdated(layout));
	};
}

export function loadFederatieOverzichtLayout() {
	return function (dispatch) {
		let layout = getDefaultLayout();
		layout.showHeader = true;
		layout.showTopNav = false;
		layout.pageHeaderTitle = "";
		layout.showBeads = false;
		resetTopNavTabSettings(layout);

		return dispatch(layoutUpdated(layout));
	};
}

export function loadExceptionPageLayout() {
	return function (dispatch) {
		let layout = getDefaultLayout();

		layout.pageHeaderTitle = "";
		layout.pageHeaderSubtitle = "";
		layout.showTopNav = false;
		layout.showSideNav = false;
		layout.showBeads = false;
		resetTopNavTabSettings(layout);

		return dispatch(layoutUpdated(layout));
	};
}

export function loadNoAccessPageLayout() {
	return function (dispatch) {

		let layout = getDefaultLayout();
		layout.showHeader = false;
		layout.pageHeaderTitle = "";
		layout.pageHeaderSubtitle = "";
		layout.showTopNav = false;
		layout.showSideNav = false;
		layout.showBeads = false;

		return dispatch(layoutUpdated(layout));
	};
}

export function loadVTTPerOrganisatorPageLayout(organisator) {
	return function (dispatch) {
		let layout = getDefaultLayout();

		layout.pageHeaderTitle = organisator;
		layout.pageHeaderSubtitle = "";
		layout.showHeader = true;
		layout.showTopNav = false;
		layout.showSideNav = false;
		layout.showBeads = false;
		resetTopNavTabSettings(layout);

		return dispatch(layoutUpdated(layout));
	};
}

export function loadOrbMigratiePageLayout(organisator) {
	return function (dispatch) {
		let layout = getDefaultLayout();

		layout.pageHeaderTitle = organisator || "";
		layout.pageHeaderSubtitle = "";
		layout.showHeader = true;
		layout.showTopNav = false;
		layout.showSideNav = false;
		layout.showBeads = false;
		resetTopNavTabSettings(layout);

		return dispatch(layoutUpdated(layout));
	};
}

export function loadKalenderGoedkeurenPageLayout(title) {
	return function (dispatch) {
		let layout = getDefaultLayout();

		layout.pageHeaderTitle = title;
		layout.showHeader = true;
		layout.showTopNav = false;
		layout.showSideNav = false;
		layout.showBeads = false;
		resetTopNavTabSettings(layout);

		return dispatch(layoutUpdated(layout));
	};
}

export function loadVTTPerGemeentePageLayout() {
	return function (dispatch) {
		let layout = getDefaultLayout();

		layout.pageHeaderTitle = "";
		layout.pageHeaderSubtitle = "";
		layout.showHeader = true;
		layout.showTopNav = false;
		layout.showSideNav = false;
		layout.showBeads = false;
		resetTopNavTabSettings(layout);

		return dispatch(layoutUpdated(layout));
	};
}

export function loadFederatieStartLayout(title) {
	return function (dispatch) {
		let layout = getDefaultLayout();

		layout.showHeader = true;
		layout.pageHeaderSubtitle = "";
		layout.showBeads = false;
		layout.showTopNav = false;
		resetTopNavTabSettings(layout);
		layout.pageHeaderTitle = title;

		return dispatch(layoutUpdated(layout));
	};
}

export function loadGemeenteStartLayout(title) {
	return function (dispatch) {
		let layout = getDefaultLayout();

		layout.showHeader = true;
		layout.pageHeaderTitle = title;
		layout.pageHeaderSubtitle = "";
		layout.showBeads = false;
		layout.showTopNav = false;
		resetTopNavTabSettings(layout);

		return dispatch(layoutUpdated(layout));
	};
}

export function loadSupportSpoVlaMedewerkerLayout() {
	return function (dispatch) {
		let layout = getDefaultLayout();

		layout.showHeader = true;
		layout.pageHeaderTitle = "VTT Support Pagina";
		layout.pageHeaderSubtitle = "";
		layout.showBeads = false;
		layout.showTopNav = false;
		resetTopNavTabSettings(layout);

		return dispatch(layoutUpdated(layout));
	};
}

function getDefaultLayout() {
	let layout = getLayout();

	layout.scope = DomainConstants.DomainScopes.ELOKET;
	layout.showHeader = false;
	layout.pageHeaderTitle = "";
	layout.pageHeaderSubtitle = "";
	layout.showTopNav = true;
	layout.showSideNav = false;
	layout.showBeads = false;
	layout.svlDossierId = "";

	return layout;
}

export function disableTopNav() {
	return function (dispatch) {
		let layout = getLayout();
		_disableTopNav(layout);
		return dispatch(layoutUpdated(layout));
	};
}

export function enableTopNav() {
	return function (dispatch) {
		let layout = getLayout();
		_enableTopNav(layout);
		return dispatch(layoutUpdated(layout));
	};
}

export function hideSideNav() {
	return function (dispatch) {
		let layout = getLayout();
		layout.showSideNav = false;
		return dispatch(layoutUpdated(layout));
	};
}

export function showSideNav() {
	return function (dispatch) {
		let layout = getLayout();
		layout.showSideNav = true;
		return dispatch(layoutUpdated(layout));
	};
}

function _disableTopNav(layout) {
	if (!layout) {
		layout = mergeDeep({}, getLayout());
	}
	Object.keys(layout.topNavTabSettings).forEach(item => {
		layout.topNavTabSettings[item].disabled = true;
	});
}

function _enableTopNav(layout) {
	if (!layout) {
		layout = mergeDeep({}, getLayout());
	}
	Object.keys(layout.topNavTabSettings).forEach(item => {
		layout.topNavTabSettings[item].disabled = false;
	});
}

export function resetTopNavTabSettings(layout) {
	layout.topNavTabsSet = false;
	layout.topNavTabSettings = {
		organisatorTab: { text: "Organisator", color: componentConstants.COLOR_ORANGE, iconType: componentConstants.ICON_ORGANISATOR, disabled: false, visible: true, urlSuffix: "/organisator/" },
		veldtoertochtTab: { text: "Tocht", color: componentConstants.COLOR_TURQUOISE_DARK, iconType: componentConstants.ICON_VELDTOERTOCHT, disabled: false, visible: true, urlSuffix: "/veldtoertocht/" },
		lussenTab: { text: capitalize(componentConstants.AFSTANDEN_TEKST), color: componentConstants.COLOR_RED, iconType: componentConstants.ICON_AFSTANDEN, disabled: false, visible: true, urlSuffix: "/lussen/" },
		publicatieTab: { text: "Publicatie", color: componentConstants.COLOR_BLUE_DARK, iconType: componentConstants.ICON_PUBLICATIE, disabled: false, visible: true, urlSuffix: "/publicatie/" },
		toelatingenTab: { text: "Goedkeuringen", color: componentConstants.COLOR_GREEN, iconType: componentConstants.ICON_TOELATINGEN, disabled: false, visible: true, urlSuffix: "/goedkeuringen/" },
		samenvattingTab: { text: "Samenvatting", color: componentConstants.COLOR_PURPLE, iconType: componentConstants.ICON_SAMENVATTING, disabled: false, visible: true, urlSuffix: "/samenvatting/" },
		naarOverzichtTab: { text: "Terug naar overzicht", color: componentConstants.COLOR_PINK, iconType: componentConstants.ICON_TERUGNAAROVERZICHT, disabled: false, visible: true, urlSuffix: "" }
	};
}

